module.exports = __webpack_public_path__ + "static/img/2.dadd004.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/2.png
// module id = EUbp
// module chunks = 48